module.exports = __webpack_public_path__ + "build/desktop/a/img/arrow.766c076aa38230f2a1eee8503d07dbf3.svg";